import React from 'react';
import PropTypes from 'prop-types';

import { createEmptyArray } from '../../../utils';

const RadioRoom = ({ id, totalRoomNumber, value, onChange, withOutline }) => {
  const rooms = createEmptyArray(totalRoomNumber);
  return (
    <div className="radio">
      {rooms.map((_, i) => {
        const roomNumber = i + 1;
        const checked = value === roomNumber;
        return (
          <div className={`radioItem ${withOutline ? 'withOutline' : ''} ${checked ? 'checked' : ''}`} key={`${id}-${i}`}>
            <input
              type="radio"
              name={`radio-${id}`}
              className="radio-input"
              id={`${id}-${i}`}
              checked={checked}
              onChange={() => onChange(roomNumber)}
            />
            <label htmlFor={`${id}-${i}`}>{roomNumber}部屋目</label>
          </div>
        );
      })}
    </div>
  );
};


RadioRoom.defaultProps = {
};

RadioRoom.propTypes = {
  id: PropTypes.string.isRequired,
  totalRoomNumber: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  withOutline: PropTypes.bool,
};

export default RadioRoom;
